import { useModal } from '@application/utils';
import { useState } from 'react';

export const useImageCropperModal = ({ onChange }: { onChange: (file: File) => void }) => {
  const modalHook = useModal({});
  const [file, setFile] = useState<File | undefined>(undefined);

  return { ...modalHook, file, setFile };
};

// export const ImageCropperModalController: FC = () => {
//   const { modal, file } = useImageCropperModal({ onChange });

//   return <ImageCropperModal modal={modal} file={file} onSave={onChange} />;
// };
